import { Injectable } from '@angular/core';
import { CONFIG } from '../../shared/config';
import { HttpGeneralService } from '../../shared';
let physiotherapyUrl = CONFIG.baseUrls.orders;
export interface PhysiotherapySession {
  docCode: number;
  dateTo: Date;
  dateFrom: Date;
  patCode: number;
  visitSerial: number;
  serviceCode: number;
  startStageCheck: boolean;
  endStageCheck: boolean;
  scheduleVplaceID: number;
}
@Injectable()
export class PhysiotherapySessionService {

  constructor(private httpGeneralService: HttpGeneralService) { }

  getPhysiotherapySession(physiotherapy: any) {
    return this.httpGeneralService.post(physiotherapy, `${physiotherapyUrl}/getPhysiotherapySession`);
  }
  getPhysiotherapySteps(physiotherapy: any) {
    return this.httpGeneralService.post(physiotherapy, `${physiotherapyUrl}/getPhysiotherapySteps`);
  }
  updatePhysiotherapySteps(physiotherapy: any) {
    return this.httpGeneralService.add(physiotherapy, `${physiotherapyUrl}/updatePhysiotherapySteps`);
  }
}
